import React, { useState } from "react";
import cn from "classnames";
import styles from "./SyncOrders.module.sass";
import Modal from "../../../../../components/Modal";
import Card from "../../../../../components/Card";
import CustomToast from "../../../../../components/CustomToast";
import { format } from "date-fns";
import Item from "../../../../../components/Schedule/Item";
import DatePicker from "react-datepicker";
import Table from "./Table/index";
import { syncOrdersByDateRange } from "../../../../../API/Store";

const SyncOrder = ({ className }) => {
  const showToast = CustomToast();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [visibleDate, setVisibleDate] = useState(false);
  const [visibleToDate, setVisibleToDate] = useState(false);

  const handleModalClose = () => {
    setIsModalVisible(false);
    setFromDate(null);
    setToDate(null);
  };

  const handleSync = async () => {
    if (!fromDate || !toDate) {
      showToast("Please select both start and end dates", "error");
      return;
    }
    try {
      const formattedFromDate = format(fromDate, "yyyy-MM-dd");
      const formattedToDate = format(toDate, "yyyy-MM-dd");
      await syncOrdersByDateRange(formattedFromDate, formattedToDate);
      showToast("Sync started successfully", "success");
      handleModalClose();
    } catch (error) {
      showToast("Failed to start sync", "error");
    }
  };

  return (
    <>
      <Card
        className={cn(styles.card, className)}
        title="Sync Order"
        classTitle="title-blue"
      >
        <div>
          <div className="rounded-lg pl-4 pr-4">
            <div className="mb-4">
              <h3>Manual Sync</h3>
              <p className="text-sm text-gray-500">
                Easily Sync Your Orders Based on a Specific Date Range to Keep
                Your Data Organized and Up-to-Date
              </p>
            </div>
            <button
              className={cn("button", styles.button)}
              onClick={() => setIsModalVisible(true)}
            >
              Start Manual Sync
            </button>
          </div>
        </div>
        <div className={cn("title-red", styles.subtitle, "mb-4 mt-12")}>
          Sync History
        </div>
        <Table />
        <Modal visible={isModalVisible} onClose={handleModalClose}>
          <div className={styles.schedule}>
            <div className={cn("title-blue", styles.title)}>
              Sync Orders by Date Range
            </div>
            <div className={styles.note}>
              Sync Your Orders Based on a Specific Date Range to Keep Your Data
              Organized and Up-to-Date.
            </div>
            <div className={styles.list}>
              <Item
                className={styles.item}
                category="From Date"
                icon="calendar"
                value={fromDate && format(fromDate, "MMMM dd, yyyy")}
                visible={visibleDate}
                setVisible={setVisibleDate}
              >
                <div className={styles.date}>
                  <DatePicker
                    selected={fromDate}
                    onChange={(date) => setFromDate(date)}
                    dateFormatCalendar={"MMMM yyyy"}
                    inline
                  />
                  <div className={styles.foot}>
                    <button
                      className={cn(
                        "button-stroke button-small",
                        styles.button
                      )}
                      onClick={() => setFromDate(null)}
                    >
                      Clear
                    </button>
                    <button
                      className={cn("button-small", styles.button)}
                      onClick={() => setVisibleDate(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Item>
              <Item
                className={styles.item}
                category="To Date"
                icon="calendar"
                value={toDate && format(toDate, "MMMM dd, yyyy")}
                visible={visibleToDate}
                setVisible={setVisibleToDate}
              >
                <div className={styles.date}>
                  <DatePicker
                    selected={toDate}
                    onChange={(date) => setToDate(date)}
                    dateFormatCalendar={"MMMM yyyy"}
                    inline
                  />
                  <div className={styles.foot}>
                    <button
                      className={cn(
                        "button-stroke button-small",
                        styles.button
                      )}
                      onClick={() => setToDate(null)}
                    >
                      Clear
                    </button>
                    <button
                      className={cn("button-small", styles.button)}
                      onClick={() => setVisibleToDate(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </Item>
            </div>
            <div className={styles.btns}>
              <button
                className={cn("button-stroke", styles.button)}
                onClick={handleModalClose}
              >
                Cancel
              </button>
              <button
                className={cn("button", styles.button)}
                onClick={handleSync}
              >
                Sync Now
              </button>
            </div>
          </div>
        </Modal>
      </Card>
    </>
  );
};

export default SyncOrder;
